import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { BsArrowUpRight, BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import { getProjectFocusLabel } from "../../data/projectData";
import {
  getSkillChipLabelWidth,
  getSkillPresentation,
} from "../shared/skillPresentation";

function ProjectCards(props) {
  const [hoveredChip, setHoveredChip] = useState(null);
  const detailDestination = props.detailTo || `/projects/${props.slug}`;
  const primaryFocusLabel = props.focusAreas?.[0]
    ? getProjectFocusLabel(props.focusAreas[0])
    : "";
  const externalLink = props.demoLink || props.ghLink;
  const secondaryLabel = props.demoLink
    ? props.demoLabel || "Walkthrough"
    : props.ghLink
      ? "Source reference"
      : "";
  const stackPreviewItems = (props.stack || []).slice(0, 4).map((label) => ({
    label,
    labelWidth: getSkillChipLabelWidth(label),
    ...getSkillPresentation(label),
  }));

  return (
    <article className="featured-proof-card featured-proof-card-compact" id={props.slug} tabIndex="-1">
      {props.imgPath ? (
        <div className="featured-proof-media">
          <img
            src={props.imgPath}
            alt={`${props.title} preview`}
            className="featured-proof-image"
          />
        </div>
      ) : null}

      <div className="featured-proof-body">
        <div className="featured-proof-content">
          <div className="featured-proof-heading-row">
            {props.featuredLabel ? (
              <span className="featured-proof-label">{props.featuredLabel}</span>
            ) : (
              <span className="featured-proof-label">Selected work</span>
            )}
            {primaryFocusLabel ? (
              <span className="featured-proof-mini-tag">{primaryFocusLabel}</span>
            ) : null}
          </div>

          <h3>{props.title}</h3>

          {props.description ? (
            <p className="featured-proof-copy">{props.description}</p>
          ) : null}

          {stackPreviewItems.length ? (
            <div className="featured-proof-stack-wrap">
              <div
                className="featured-proof-stack"
                aria-label={`${props.title} stack preview`}
                onMouseLeave={() => setHoveredChip(null)}
              >
                {stackPreviewItems.map(({ Icon, color, label, labelWidth }) => (
                    <span
                      key={`${props.slug}-${label}`}
                      className={`featured-proof-stack-chip${hoveredChip === label ? " is-hovered" : ""}`}
                      style={{
                        "--stack-chip-color": color,
                        "--stack-chip-label-width": labelWidth,
                      }}
                      tabIndex={0}
                      title={label}
                      aria-label={label}
                      onMouseEnter={() => setHoveredChip(label)}
                      onFocus={() => setHoveredChip(label)}
                      onBlur={() => setHoveredChip(null)}
                    >
                      <Icon aria-hidden="true" />
                      <span className="featured-proof-stack-chip-label">{label}</span>
                    </span>
                  ))}
              </div>
            </div>
          ) : null}
        </div>

        <div className="featured-proof-actions">
          <Button as={Link} to={detailDestination}>
            <BsArrowUpRight aria-hidden="true" />
            <span>Details</span>
          </Button>

          {externalLink ? (
            <Button
              as="a"
              href={externalLink}
              target="_blank"
              rel="noopener noreferrer"
              variant="outline-light"
              aria-label={`Open ${props.title} ${props.demoLink ? "walkthrough" : "source reference"} in a new tab`}
            >
              {props.demoLink ? <CgWebsite /> : <BsGithub />}
              <span>{secondaryLabel}</span>
            </Button>
          ) : null}
        </div>
      </div>
    </article>
  );
}

export default ProjectCards;
